document.documentElement.classList.remove('no-js');

// =============================================================================
// Header Components
// =============================================================================
import { initHeaderScroll } from './components/header/headerScroll.js';
import { initDesktopSearch } from './components/header/desktopSearch.js';
initHeaderScroll();
initDesktopSearch();

// =============================================================================
// Navigation Components
// =============================================================================
import { initNavPanel } from './components/nav/navPanel.js';
import { initDesktopNav } from './components/nav/desktopNav.js';
import { initSubMenu } from './components/nav/subMenu.js';
initNavPanel();
initDesktopNav();
initSubMenu();

// =============================================================================
// Form Handler
// =============================================================================
import { formHandler } from './components/formHandler.js';
formHandler();

// =============================================================================
// Newsletter Form (Constant Contact)
// =============================================================================
import { initNewsletterForm } from './components/newsletterForm.js';
initNewsletterForm();

// =============================================================================
// Markets Slider
// =============================================================================
import { initMarketsSlider } from './components/marketsSlider.js';
initMarketsSlider();

// =============================================================================
// History Timeline Slider
// =============================================================================
import { initHistoryTimelineSlider } from './components/historyTimelineSlider.js';
initHistoryTimelineSlider();

// =============================================================================
// Tabs
// =============================================================================
import { initTabs } from './components/tabs.js';
initTabs();

// =============================================================================
// SVG Morph Animation
// =============================================================================
// import { initSvgMorph } from './components/svgMorph.js';
// initSvgMorph();

// =============================================================================
// SVG Inline
// =============================================================================
import { initSvgInline } from './components/svgInline.js';
initSvgInline();

// =============================================================================
// Page Fade-In/Out
// =============================================================================
import { initPageFadeIn, initPageFadeOut } from './animations/page-fade.js';
initPageFadeIn();
initPageFadeOut();

// =============================================================================
// Animations
// =============================================================================

// General
import { initGeneralAnimations } from './animations/general.js';
initGeneralAnimations();

// Parallax Effects
import { initParallax } from './animations/parallax.js';
initParallax();

// Front Page
import { initFrontPageAnimations } from './animations/front-page.js';
initFrontPageAnimations();

// Typewriter
import { initTypewriterAnimations } from './animations/typewriter.js';
if (document.querySelector('[data-typewriter-strings]')) {
  initTypewriterAnimations();
}

// Color Cards (wait for SVG inline to complete)
import { colorCardsAnimations } from './animations/color-cards.js';
if (document.querySelector('.color-cards')) {
  // Delay to allow SVG inline to process icons first
  setTimeout(() => {
    colorCardsAnimations();
  }, 1500);
}

// =============================================================================
// Fancybox
// =============================================================================
import { fancyBox } from './vendors/fancyBox.js';
fancyBox();

// =============================================================================
// Post Filters
// =============================================================================
import { initPostFilters } from './components/postFilters.js';
if (document.body.classList.contains('page-template-page-news')) {
  initPostFilters();
}

// =============================================================================
// Copy to Clipboard
// =============================================================================
import { initCopyToClipboard } from './components/copyToClipboard.js';
initCopyToClipboard();

// =============================================================================
// Image Alignment
// =============================================================================
import { initImageAlignment } from './components/imageAlignment.js';
// Initialize image alignment if data-image-align attribute exists on the page
if (document.querySelector('[data-image-align]')) {
  initImageAlignment();
}

// =============================================================================
// Hash Link Scroll (after all animations/ScrollTrigger initialized)
// =============================================================================
if (window.location.hash) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const target = document.querySelector(window.location.hash);
      if (target) {
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial')) || 0;
        window.scrollTo({
          top: target.offsetTop - headerHeight - 32,
          behavior: 'smooth'
        });
      }
    }, 300);
  });
}